import styled from 'styled-components'

type LabelErrorProps = {
	visible: boolean
}

export const Title = styled.h3`
	font-family: 'Montserrat', sans-serif;
	color: #5082c2;
	text-align: center;
	padding: 0 20px 12px 20px;
`

export const PaymentContainer = styled.div`
	width: 100%;
`

export const FormGroup = styled.div`
	max-width: 100%;
	padding: 6px 10px;
	margin: 0px 24px 0 24px;
`

export const CardLabel = styled.label`
	line-height: 1.2;
	margin: 5px 5px 0 5px;
	font-size: 14px;
	font-family: 'Montserrat', sans-serif;
	font-weight: 500;
	color: #64778f;
`

export const LabelError = styled.label<LabelErrorProps>`
	font-family: 'Montserrat', Arial, sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #c22a58;
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
	margin-left: 4px;
`
